<template>
    <popper
        trigger="click"
        class="jgile-dropdown-tree"
        :class="{ active: active }"
        @show="show"
        @hide="hide"
        :options="{ placement: placement }"
        :visible-arrow="false"
        v-if="nodes"
    >
        <div class="popper jgile-popper">
            <t-tree :int-val="intVal" :name="name" :nodes="nodes" :options="options" :value="value" @input="treeChanged"></t-tree>
        </div>
        <button class="form-control" type="button" slot="reference">
            <template v-if="selectionLength"> {{ selectionLength }} selected</template>
            <template v-else>
                <slot name="placeholder">
                    <span class="placeholder">
                        {{ placeholder }}
                    </span>
                </slot>
            </template>
            <i class="fal fa-fw fa-chevron-down"></i>
        </button>
    </popper>
</template>

<script>
import TreeNode from './Tree';

export default {
    components: { TreeNode },
    props: {
        nodes: {
            type: Array,
            required: true,
        },
        name: {
            required: true,
        },
        value: {
            required: false,
        },
        placeholder: {
            default: 'Select',
        },
        lazy: {
            default: false,
        },
        options: {
            type: Object,
            default: () => {
                return {};
            },
        },
        placement: {
            default: 'bottom-end',
        },
        intVal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectionLength: 0,
            active: false,
            storedValue: null,
        };
    },
    methods: {
        hide() {
            this.active = false;
            if (this.lazy) {
                this.emit(this.storedValue);
            }
        },
        show() {
            this.active = true;
        },
        treeChanged(val) {
            if (this.lazy) {
                this.storedValue = val;
            } else {
                this.emit(val);
            }
        },
        emit(newVal) {
            this.processValue(newVal);
            this.$emit('input', this.storedValue);
        },
        processValue(newVal) {
            if (Array.isArray(newVal)) {
                if (newVal.length === 1 && newVal[0] === '') {
                    newVal = [];
                }
            } else {
                newVal = [];
            }

            this.storedValue = _.filter(this.intVal ? _.map(newVal, (item) => _.toInteger(item)) : newVal, (item) => {
                return item !== null && item !== undefined;
            });
            this.selectionLength = this.storedValue.length;
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.processValue(newVal);
                }
            },
        },
    },
};
</script>

<style>
.jgile-dropdown-tree > button > i,
.jgile-dropdown-tree > button > .svg-inline--fa {
    transition: all 0.3s;
}

.jgile-dropdown-tree.active > button > i,
.jgile-dropdown-tree.active > button > .svg-inline--fa {
    transform: rotate(180deg);
}
</style>
